// This function allow to reference chunks
__webpack_require__.u = (chunkId) => {
  // return url for filenames not based on template
  
  // return url for filenames based on template
  return "" + ({1568: "4-feat-report-one-ds-event",17171: "4-auth-msal",34487: "3-render-loginrenderer",53341: "2-polyfill-idle",69273: "4-feat-protobuf-client-properties",82983: "3-render-highContrastEmulation",84303: "4-feat-protobuf-scenario-type",94973: "4-feat-initialize-one-ds",97995: "4-feat-protobuf-request",}[chunkId] || chunkId) + ".js"
}